<template src="./search-field.html"></template>

<script lang="ts">
import { nextTick } from 'vue'

export default {
  props: {
    describedBy: { type: String },
    fieldId: { type: String }, // when using input where label has "for" attribute
    labelId: { type: String }, // when using div where label has an id
    modelValue: String,
    multiline: Boolean,
    placeholder: String, // placeholder text, only used in input field (!multiline)
    showSearchIcon: Boolean
  },
  emits: ['update:modelValue', 'focus'],
  methods: {
    clearText() {
      this.$emit('update:modelValue', '')
      nextTick(() => this.$refs.field.focus())
    },
    update(e) {
      this.$emit('update:modelValue', this.multiline ? e.target.innerText : e.target.value)
    },
    focus() {
      this.$emit('focus')
    }
  },
  watch: {
    modelValue() {
      if (this.multiline && this.modelValue.length === 0) {
        this.$refs.field.innerText = ''
      }
    }
  }
}
</script>

<style lang="scss" src="./search-field.scss"></style>
